import styled from 'styled-components'
import { respondTo } from '../../../../../styles/_respondTo'

export const StyledH2 = styled.h2`
  margin: 0px;
  margin-bottom: 10px;
  color: #F7DF1E;
  font-weight: bold;

  ${respondTo.lg`
  font-size: 2rem;
  `}

  ${respondTo.xl`
  font-size: 2rem;
  `}
`